import { render, staticRenderFns } from "./BrandsOnboardingModal.vue?vue&type=template&id=83ac9112&scoped=true&"
import script from "./BrandsOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./BrandsOnboardingModal.vue?vue&type=script&lang=js&"
import style1 from "./BrandsOnboardingModal.vue?vue&type=style&index=1&id=83ac9112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac9112",
  null
  
)

export default component.exports